import React from "react";
import AboutUsData from "./AboutUsData";
import "../components/AboutUsStyles.css";
import ClientHeadshot from "../assets/homepagephotos/clientphoto.png"

function AboutUs() {
  return (
    <div className="bio-container">
      <h1 className="section-heading">Biography</h1>
      <AboutUsData
          text="With over two decades of experience at the intersection of finance,
        intelligence, and global security, Susan has dedicated her career to
        advancing financial integrity, disrupting illicit networks, and building
        resilient institutions across the Middle East, Southwest Asia, and South
        America."

          text2="She has served within the U.S. intelligence and law enforcement
        communities and at the Departments of State and Treasury, including the
        Office of Intelligence and Analysis (OIA), Office of Technical Assistance
        (OTA), Office of Foreign Assets Control (OFAC), the Committee on Foreign
        Investment in the United States (CFIUS), and the Terrorist Finance
        Targeting Center (TFTC). Her work has focused on countering terrorist
        financing, arms and narcotics trafficking, human smuggling, and
        transnational corruption, with a strong emphasis on strengthening
        partner-nation institutions and building enduring capacity."

          text3="Susan was also a plank owner of Project Thor, a multi-agency special
        operation that identified Mexican drug cartel networks operating within
        the United States and dismantled their gun-smuggling pipelines."
          img={ClientHeadshot}
        />
      <br></br>
      <p>
        In 2010, she played a pivotal role in establishing Iraq's Financial
        Intelligence Unit (FIU) and contributed to the recovery of nearly $1
        billion in stolen sovereign assets-a landmark achievement that
        strengthened Iraq's financial sovereignty and international credibility.
      </p>
      <p>
        As the founder of FCG Consultancy and the Financial Diplomacy Initiative
        (FinDIP), Susan continues to bridge policy, finance, and security,
        supporting fragile and reforming economies in developing transparent and
        resilient financial systems. Her advisory work centers on regulatory
        modernization, sanctions compliance, and institutional reform, guiding
        governments toward improved governance, accountability, and regional
        cooperation.
      </p>
      <p>
        She believes that financial diplomacy is the bridge between stability
        and sovereignty-a catalyst for aligning strategic governance with
        international partnership and a foundation for integrity, trust, and
        lasting prosperity.
      </p>
    </div>
  );
}

export default AboutUs;
